import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast, Toaster } from "sonner";
import { Lock, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/auth/login", { email: email.toLowerCase(), password: pw });
      localStorage.setItem("ch_token", r.data.token);
      localStorage.setItem("ch_email", r.data.email);
      nav("/admin");
    } catch (e) {
      toast.error("Invalid credentials");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0D0E11] diamond-plate flex items-center justify-center p-4">
      <Toaster theme="dark" />
      <form onSubmit={submit} className="shop-card p-8 w-full max-w-md">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 bg-red-600 rounded-sm flex items-center justify-center border-2 border-red-500/60"><Lock className="w-5 h-5 text-white" /></div>
          <div>
            <div className="font-display font-black text-white text-2xl uppercase">Shop Board</div>
            <div className="eyebrow">Admin Access Only</div>
          </div>
        </div>
        <label className="block mb-4">
          <div className="eyebrow mb-1">Email</div>
          <input data-testid="admin-email" required type="email" value={email} onChange={e => setEmail(e.target.value)} className="input" />
        </label>
        <label className="block mb-6">
          <div className="eyebrow mb-1">Password</div>
          <input data-testid="admin-password" required type="password" value={pw} onChange={e => setPw(e.target.value)} className="input" />
        </label>
        <button type="submit" data-testid="admin-login-btn" disabled={busy} className="btn-red w-full py-4 rounded-sm inline-flex justify-center items-center gap-2">
          {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : null} Sign In
        </button>
      </form>
    </div>
  );
}
